import React from 'react';
import { FiFileText, FiZap } from 'react-icons/fi';

export default function FacturasListQuickCta({
  heroBg,
  textPri,
  textSec,
  modoOscuro,
  btnOut,
  onQuickSale,
  onCompleteSale,
}) {
  return (
    <section className={`rounded-2xl border p-4 sm:p-5 ${heroBg}`}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
        <div className="min-w-0 flex-1">
          <p className={`text-[11px] font-semibold uppercase tracking-wide ${modoOscuro ? 'text-[#5CA3FF]' : 'text-[#004AAD]'}`}>
            Forma más rápida
          </p>
          <h2 className={`mt-1 text-base font-semibold sm:text-lg ${textPri}`}>
            ¿Acabás de realizar una venta?
          </h2>
          <p className={`mt-1 text-xs sm:text-sm ${textSec}`}>
            Registrá importe, concepto y cobro en pocos pasos, o usá la carga completa si necesitás más detalle.
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <button
            type="button"
            onClick={onQuickSale}
            className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#1F80FF] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#004AAD]"
          >
            <FiZap className="h-4 w-4" />
            Venta rápida
          </button>
          <button
            type="button"
            onClick={onCompleteSale}
            className={`inline-flex items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold ${btnOut}`}
          >
            <FiFileText className="h-4 w-4" />
            Carga completa
          </button>
        </div>
      </div>
    </section>
  );
}
